export const SVG_NS = 'http://www.w3.org/2000/svg';
export const XLINK_NS = 'http://www.w3.org/1999/xlink';
export const XMLNS_NS = 'http://www.w3.org/2000/xmlns/';
